import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-company",
  "use": "icon-icon-company-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-company\">\r\n<path d=\"M0 20V3.33333L13.3333 0V4.83333L20 7.5V20H0ZM11.6667 2.13417L1.66667 4.63417V18.3333H11.6667V2.13417ZM13.3333 6.6275V18.3333H18.3333V8.6275L13.3333 6.6275ZM16.6667 12.5V15H15V12.5H16.6667ZM9.16667 13.3333V15H4.16667V13.3333H9.16667ZM9.16667 8.33333V10H4.16667V8.33333H9.16667Z\" fill=\"black\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol